import React from "react";
import { object, array, bool, number, string } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card13.m.css";

const StoryCard13 = ({
  index,
  story,
  aspectRatio,
  imageType,
  headerType,
  showAuthorName,
  id,
  showRedDot,
  headerLevel
}) => {
  return (
    <div className="story-card story-card-13" styleName="story-card-13" id={`story-card-13-${index}`}>
      <Link href={`/${story.slug}`}>
        <div styleName="row1">
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            showAuthorName={showAuthorName}
            showStoryTypeIcon
            showVideoIcon={true}
          />
          <div>
            <Headline
              text={story.headline}
              headerType={headerType}
              headerLevel={headerLevel}
              story={story}
              width={20}
              height={20}
              id={id}
              lineClamp={3}
              showRedDot={showRedDot}
            />
            <StoryDate story={story} />
          </div>
        </div>
      </Link>
    </div>
  );
};

StoryCard13.defaultProps = {
  index: 1,
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard13.propTypes = {
  index: number,
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard13;
